module.exports = __webpack_public_path__ + "img/ifm.1bd04239.png";